import { Subscription } from "rxjs";
import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { NgSelectDynamicOptionsText } from "./models/ng-select-dynamic-options-text.model";
import { NgSelectDynamicServiceService } from "./services/ng-select-dynamic-service.service";
import { v4 as uuidv4 } from "uuid";

@Component({
    selector: "app-ng-select-dynamic",
    templateUrl: "./ng-select-dynamic.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: NgSelectDynamicComponent,
        },
    ],
    standalone: false
})

//ng-select dinàmic, utilitzar per cercar. Compatible amb ngForms i ngModel, podem afegir totes les funcionalitzats que necessitem de ng-select
export class NgSelectDynamicComponent
  implements OnInit, OnChanges, OnDestroy, ControlValueAccessor
{
  @Input() elementId?: string = uuidv4(); //If we want to access the element using DOM
  @Input() placeholder: string = "...";
  @Input() apiPath: string;
  @Input() listMethodPath: string;
  @Input() singleMethodPath: string = ""; //Could be empty
  @Input() bindValue: string; //if null, return whole object
  @Input() slice = [0, 20];
  @Input() optionText: NgSelectDynamicOptionsText;
  @Input() bindLabel: string; //Bind label has priority before optionText
  @Input() disabled: boolean = false;
  @Input() clearable: boolean = true;
  @Input() serverResponse: boolean = true; //If response is returned with serverResponse structure
  @Input() translate: boolean = false; //If we want to translate the text
  @Output() change: EventEmitter<any> = new EventEmitter();
  touched = false;
  loading = false;
  values: any;
  selectedValueInstance: any; //Selected object to unshift into values list
  selectedValue: any; //Depends on input

  private singleSubscription: Subscription;
  private listSubscription: Subscription;

  constructor(
    public ngSelectDynamicServiceService: NgSelectDynamicServiceService
  ) {}

  ngOnInit(): void {
    this.updateValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.apiPath || changes.listMethodPath) {
      this.updateValues();
    }
  }

  setSelectedValueInstance(): void {
    if (
      !this.selectedValueInstance ||
      this.selectedValueInstance[this.bindValue] !== this.selectedValue
    ) {
      if (this.selectedValue && this.bindValue) {
        this.selectedValueInstance = this.values.find(
          (x) => x[this.bindValue] == this.selectedValue
        );
        if (!this.selectedValueInstance) {
          if (this.singleSubscription) this.singleSubscription.unsubscribe();
          this.singleSubscription = this.ngSelectDynamicServiceService
            .getValue(this.apiPath, this.singleMethodPath, this.selectedValue)
            .subscribe({
              next: (data) => {
                this.selectedValueInstance = data;
                this.values.unshift(this.selectedValueInstance);
              },
            });
        }
      }
    } else {
      this.values.unshift(this.selectedValueInstance);
    }
  }

  updateValues(filter?): void {
    this.loading = true;
    if (this.listSubscription) this.listSubscription.unsubscribe();
    this.listSubscription = this.ngSelectDynamicServiceService
      .getValues(this.apiPath, this.listMethodPath, this.serverResponse, filter)
      .subscribe({
        next: (data) => {
          this.values = data;
          this.setSelectedValueInstance();
          this.loading = false;
        },
        error: (_) => {
          this.loading = false;
        },
      });
  }

  onChange = (value) => {};

  onTouched = () => {};

  onSelectValue(value): void {
    this.markAsTouched();
    this.onChange(value);
    this.change.emit(value);
  }

  writeValue(value: any) {
    this.selectedValue = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  ngOnDestroy(): void {
    if (this.singleSubscription) this.singleSubscription.unsubscribe();
    if (this.listSubscription) this.listSubscription.unsubscribe();
  }
}
